import React, { Fragment, useCallback, useEffect, useState } from "react";
import { Form, Formik } from "formik";
import { toast } from "react-toastify";
import generalSettings from "@apis/generalSettings";
import CardHeader from "@commons/businesscardHeader";
import Fields from "@components/fields";
import Row from "@components/row";
import Wrapper from "@components/wrapper";
import Button from "@components/button";
import { useSelector } from "react-redux";
import { RootState } from "@store/index";
import { Module } from "@apis/index";

const ModuleWisePrice = () => {
  const { data: modules } = useSelector((state: RootState) => state.modules);
  const [existing, setExisting] = useState<any | null>(null);
  const [infoFields, setInfoFields] = useState<string[]>([]);
  const fetchModules = useCallback(async () => {
    await Module.list({ state: "modules" });
  }, []);
  const fetchBusinessRules = useCallback(async () => {
    try {
      const data = await generalSettings.getByKey({
        id: "module-wise-price",
        state: "modulesPrice",
        showErr: false,
      });
      if (data) {
        setExisting(data);
        const parsed = data?.infos ?? {};
        const infoKeys = Object.keys(parsed);
        setInfoFields(infoKeys);
      }
    } catch (err) {
      console.error("Failed to fetch business rules", err);
    }
  }, []);

  useEffect(() => {
    fetchBusinessRules();
    fetchModules();
  }, [fetchBusinessRules, fetchModules]);

  const handleSubmit = async (values: any) => {
    const payload: any = {
      key: "module-wise-price",
      infos: JSON.stringify(values),
    };

    if (!existing?.id) {
      payload.group = "business-settings";
    }

    try {
      if (existing?.id) {
        await generalSettings.update({
          id: existing.id,
          state: "modulesPrice",
          data: payload,
        });
        toast.success("Module wise price updated successfully!");
      } else {
        await generalSettings.create({
          state: "modulesPrice",
          data: payload,
        });
        toast.success("Module wise price created successfully!");
      }
      fetchBusinessRules();
    } catch (err) {
      console.error("Failed to save module wise price", err);
      toast.error("Failed to save module wise price");
    }
  };

  const formatLabel = (key: string) => {
    return (
      key
        .replace("Percentage", "")
        .replace(/([A-Z])/g, " $1")
        .replace(/^./, (str) => str.toUpperCase())
        .trim() + " (Rs)"
    );
  };

  const getPlaceholder = (key: string) => {
    return "1000 (Rs)";
  };

  const getInitialValues = () => {
    if (!existing?.infos) return {};

    const initialValues: { [key: string]: string } = {};

    if (Array.isArray(modules)) {
      modules.forEach((module) => {
        const key = `${module.name}-${module.id}`;
        initialValues[key] = existing.infos[key] || "";
      });
    }

    return initialValues;
  };

  return (
    <Fragment>
      <Formik
        enableReinitialize
        initialValues={getInitialValues()}
        onSubmit={handleSubmit}
      >
        <Form>
          <CardHeader title="Module Wise Platform Fee (Rs)" />
          <Wrapper>
            <Row styleRow="display: grid; grid-template-columns: repeat(6, 1fr); gap: 1rem;">
              {modules.map((module) => (
                <Fields.Input
                  key={module.id}
                  name={`${module.name}-${module.id}`}
                  label={formatLabel(module.name)}
                  placeholder={getPlaceholder(module.name)}
                />
              ))}
            </Row>

            <br />
            <Button
              type="submit"
              title={existing ? "Update" : "Save"}
              justify="end"
            />
          </Wrapper>
        </Form>
      </Formik>
    </Fragment>
  );
};

export default ModuleWisePrice;
